import Card from 'components/Containers/Card';
import React from 'react';
import { Link } from 'react-router-dom';
import MyLayout from './MyLayout';
import Exerciselist from './Exerciselist';
import CreateExerciseByUnit from './CreateExerciseByUnit';
import CreateClass from './CreateClass';
import DragDrop from './DragDrop';

export default function index() {
  return (
    <div className='p-3'>
      {/* <Link to='/lms/CanvasToolPage'>CanvasToolPage</Link>
      <br />
      <Link to='/lms/ExcercisePage'>ExcercisePage</Link>
      <MyLayout />
      <Exerciselist />
      <CreateClass />
      <CreateExerciseByUnit /> */}
      <DragDrop />
    </div>
  );
}
